import {
  FETCH_HISTORY_END,
  FETCH_HISTORY_START,
  SAVE_HISTORY,
  SAVE_HISTORY_PAGE,
  SAVE_HISTORY_START
} from "appRedux/constants";

const INIT_STATE = {
  loading: false,
  histories: [],
  loading_stats: false,
  stats: [],
  historyPages: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_HISTORY_START: {
      return {
        ...state,
        loading: true
      };
    }
    case FETCH_HISTORY_END: {
      return {
        ...state,
        loading: false
      };
    }
    case SAVE_HISTORY_START: {
      return {
        ...state,
        loading: true
      };
    }
    case SAVE_HISTORY: {
      return {
        ...state,
        loading: false,
        histories: action.payload
      };
    }
    case SAVE_HISTORY_PAGE: {
      return {
        ...state,
        loading: false,
        historyPages: action.payload
      };
    }

    default:
      return state;
  }
};
